import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
// Services
import { CollectStatusInsertService } from '../../service/collect-status-insert/collect-status-insert.service';

@Component({
	selector: 'app-collect-status-insert',
	templateUrl: './collect-status-insert.component.html',
	providers: [
		CollectStatusInsertService,
		HttpModule
	]
})
export class CollectStatusInsertComponent implements OnInit {

	private token;
	collectStatusForm: FormGroup;
	Descricao: string = "";
	efetivaStatus: boolean = false;
	padraoStatus: boolean = false;
	Ativo: boolean = false;
	public permissoes: any[] = [];

	constructor(fb: FormBuilder, private collectStatusInsertService: CollectStatusInsertService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.collectStatusForm = fb.group({
			'Descricao': [null, Validators.compose([Validators.required, Validators.maxLength(60)])],
			'Padrao': '',
			'CobrancaEfetiva': '',
			'NaoCobranca': '',
			'ContaExposicao': '',
			'BloqueioOrdem': '',
			'Ativo': false
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
	}

	addCollectStatus(value: any) {
		this.collectStatusInsertService.insertCollectStatus(this.token, value).subscribe(result => {
			if (result.Success)
				this.router.navigateByUrl('/status-cobranca');

		}, error => {
			console.log(error);

		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/status-cobranca');
	}

}



// WEBPACK FOOTER //
// ./src/app/collect-status/component/collect-status-insert/collect-status-insert.component.ts